import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type CommentModalOptions = { text?: string; required?: boolean };

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  standalone: false,
})
export class CommentComponent implements OnInit {
  public commentForm: UntypedFormGroup;
  public options: CommentModalOptions = {};
  public submitted: boolean = false;
  private confirmCallback: (comment?: string) => void;
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    public modal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    this.commentForm = this.formBuilder.group({
      comment: [undefined, this.options?.required ? [Validators.required] : []],
    });
  }

  public async confirm(): Promise<string> {
    return new Promise<string>((resolve: (value: string) => void) => {
      this.confirmCallback = (comment: string): void => {
        this.modal.close();
        resolve(comment);
      };
    });
  }

  public accept(): void {
    this.submitted = true;
    if (this.commentForm.valid) {
      this.confirmCallback(this.commentForm.controls.comment.value ?? '');
    }
  }

  public cancel(): void {
    this.confirmCallback(null);
  }

  public setOptions(options: CommentModalOptions) {
    Object.assign(this.options, options);
  }
}
